export default {
      id: "soundcloud-usage",
      viewBox: "0 0 799.997 351.669",
      url: "../../assets/" + "sprite.svg#soundcloud-usage",
      toString: function () {
        return this.url;
      }
    }